import { getRequest, patchRequest } from 'features/common'
import settings from 'settings'
import { TaskList } from '../types'

function baseUrl(type: TaskList = TaskList.Onboarding) {
  const { workspaceApiUrl } = settings
  return `${workspaceApiUrl}/tasks/${type}`
}

export const getOnboardingChecklist = async () => {
  const onboardingChecklist = await getRequest(baseUrl())
  return onboardingChecklist
}

export const completeOnboardingChecklist = async (tasksIds: string[]) => {
  const onboardingChecklist = await patchRequest(baseUrl(), { completed: tasksIds })
  return onboardingChecklist
}

export const getOnboardingSFPartnerConnect = async () => {
  const onboardingChecklist = await getRequest(baseUrl(TaskList.SnowflakePartnerConnect))
  return onboardingChecklist
}

export const getAIAgentOnboardingStatus = async () => {
  const AIAgentTask = await getRequest(baseUrl(TaskList.AIAgent))
  return AIAgentTask
}

export const completeSFPartnerConnectTasks = async (tasksIds: string | string[]) => {
  const tasks = Array.isArray(tasksIds) ? tasksIds : [tasksIds]
  const onboardingChecklist = await patchRequest(baseUrl(TaskList.SnowflakePartnerConnect), { completed: tasks })
  return onboardingChecklist
}

export const completeAIAgentTasks = async (tasksIds: string | string[]) => {
  const tasks = Array.isArray(tasksIds) ? tasksIds : [tasksIds]
  const AIAgentTask = await patchRequest(baseUrl(TaskList.AIAgent), { completed: tasks })
  return AIAgentTask
}
